/* activity: перевод строк заметок и задач (activity.tsx, activity-api.ts), раздела «Задачи» и блоков в карточках контакта и сделки. Ключ — русская строка как в коде. */
const d: Record<string, string> = {
  "Задачи": "Tasks",
  "Мои задачи и сроки": "My tasks and deadlines",
  "Задачи — мои и команды": "Tasks — mine and the team's",
  "Задачи из Zoho CRM и новые из Hub: просроченные, на сегодня, на неделе; к контакту, сделке или компании. Заметки и задачи живут в карточках контакта и сделки.":
    "Tasks from Zoho CRM and new ones from Hub: overdue, today, this week; linked to a contact, deal or company. Notes and tasks live in the contact and deal cards.",
  "Заметки": "Notes",
  "Удалить заметку?": "Delete this note?",
  "Новая заметка… (⌘↵ — сохранить)": "New note… (⌘↵ to save)",
  "Новая заметка": "New note",
  "Добавить": "Add",
  "изменить": "edit",
  "удалить": "delete",
  "Показать все ({n})": "Show all ({n})",
  "Заметок пока нет.": "No notes yet.",
  "Текст заметки": "Note text",
  "Сохранить": "Save",
  "Отмена": "Cancel",
  "скрыть сделанные": "hide done",
  "со сделанными": "with done",
  "Задача": "Task",
  "Задач нет.": "No tasks.",
  "Сделано": "Done",
  "просрочено · {d}": "overdue · {d}",
  "важно": "important",
  "отложена": "deferred",
  "низкий": "low",
  "обычный": "normal",
  "высокий": "high",
  "Что сделать": "What to do",
  "Название задачи": "Task title",
  "Подробности (необязательно)": "Details (optional)",
  "Подробности": "Details",
  "Срок": "Due date",
  "Приоритет": "Priority",
  "Ответственный": "Assignee",
  "Сохраняю…": "Saving…",
  "Создать": "Create",
  "Просрочено": "Overdue",
  "Сегодня": "Today",
  "На неделе": "This week",
  "Позже": "Later",
  "Без срока": "No due date",
  "Задача снова открыта": "Task reopened",
  "Задача сделана": "Task done",
  "Удалить задачу «{title}»?": "Delete task “{title}”?",
  "Мои": "Mine",
  "Все": "All",
  "В работе": "Open",
  "Сделанные": "Done",
  "Поиск по задачам": "Search tasks",
  "Показано {n} из {total}": "Showing {n} of {total}",
  "у меня в работе {n}": "{n} open for me",
  "задач": "task|tasks",
  "просрочено {n}": "{n} overdue",
  "на сегодня {n}": "{n} for today",
  "Задача создана": "Task created",
  "Задача сохранена": "Task saved",
  "Удалить задачу": "Delete task",
  "Задач нет — хорошая новость.": "No tasks — good news.",
};
export default d;
